import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const TriangleRight = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ _jsx("svg", {
        ref: ref,
        ...props,
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M13.62 22.92A1 1 0 0113 22V10a1 1 0 01.62-.92 1 1 0 011.09.21l6 6a1 1 0 010 1.42l-6 6a1 1 0 01-1.09.21z"
        })
    }));
TriangleRight.displayName = "TriangleRight";
